export default [
  {
    header: 'Генератор',
  },
  {
    title: 'Пакеты',
    route: 'generator-packs',
    icon: 'PackageIcon',
    tagVariant: 'light-warning',
  },
]
